(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["infinite-carousel"] && !Shopify.designMode) return;
  try {
    
  const loadInfiniteCarouselImage = (image) => {
    const source = image.dataset.infiniteCarouselSrc;
    if (!source) return;

    image.src = source;
    image.removeAttribute('data-infinite-carousel-src');
  };

  const infiniteCarouselObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        loadInfiniteCarouselImage(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '600px 0px' }
  );

  const observeInfiniteCarouselImages = (root = document) => {
    root.querySelectorAll('[data-infinite-carousel-src]').forEach((image) => {
      infiniteCarouselObserver.observe(image);
    });
  };

  observeInfiniteCarouselImages();
  document.addEventListener('shopify:section:load', (event) => observeInfiniteCarouselImages(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCategoryTracks = (root) => {
      root.querySelectorAll('[data-v2-category-carousel] .v2-category-grid').forEach((track) => {
        if (track.dataset.directScrollReady === 'true') return;
        track.dataset.directScrollReady = 'true';

        let pointerId = null;
        let startX = 0;
        let startScrollLeft = 0;
        let didDrag = false;
        let pendingScrollLeft = 0;
        let animationFrame = null;

        const renderDrag = () => {
          track.scrollLeft = pendingScrollLeft;
          animationFrame = null;
        };

        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          pointerId = event.pointerId;
          startX = event.clientX;
          startScrollLeft = track.scrollLeft;
          pendingScrollLeft = startScrollLeft;
          didDrag = false;
        });

        track.addEventListener('pointermove', (event) => {
          if (event.pointerId !== pointerId) return;
          if ((event.buttons & 1) === 0) {
            finishDrag(event);
            return;
          }
          const distance = startX - event.clientX;
          if (!didDrag && Math.abs(distance) < 5) return;
          if (!didDrag) {
            didDrag = true;
            track.classList.add('is-dragging');
            track.setPointerCapture(pointerId);
          }
          pendingScrollLeft = startScrollLeft + distance;
          if (animationFrame === null) animationFrame = window.requestAnimationFrame(renderDrag);
          event.preventDefault();
        });

        const finishDrag = (event) => {
          if (event.pointerId !== pointerId) return;
          if (animationFrame !== null) {
            window.cancelAnimationFrame(animationFrame);
            renderDrag();
          }
          if (track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId);
          pointerId = null;
          track.classList.remove('is-dragging');
          window.setTimeout(() => { didDrag = false; }, 0);
        };

        track.addEventListener('pointerup', finishDrag);
        track.addEventListener('pointercancel', finishDrag);
        track.addEventListener('pointerleave', (event) => {
          if (event.pointerId !== pointerId || didDrag || track.hasPointerCapture(pointerId)) return;
          pointerId = null;
          didDrag = false;
        });
        track.addEventListener('click', (event) => {
          if (!didDrag) return;
          event.preventDefault();
          event.stopPropagation();
        }, true);
        track.addEventListener('dragstart', (event) => event.preventDefault());
      });
    };

    initializeCategoryTracks(document);
    document.addEventListener('shopify:section:load', (event) => initializeCategoryTracks(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
